import { Router } from "@vaadin/router";
import {
  LitElement,
  TemplateResult,
  property,
  customElement,
  css,
} from "lit-element";
import { html, render } from "lit-html";
import { storeInstance } from "store/index.js";
import "@vaadin/vaadin-icons/vaadin-icons.js";
import "@ui5/webcomponents/dist/TextArea";

class KbCommentForm extends LitElement {
  constructor() {
    super();
    this.comment = "";
  }

  connectedCallback() {
    this.subscription = storeInstance.subscribe((state) => {
      this.stateChange(state);
    });
    this.state = storeInstance.state;
    this.string = this.state.strings;
    PubSub.subscribe("commentsaved", this._commentSaved.bind(this));
    this.myRender();
  }

  disconnectedCallback() {
    storeInstance.unsubscribe(this.subscription);
  }

  stateChange(state) {
    this.state = state;
    this.string = this.state.strings;
    this.myRender();
  }

  myRender() {
    render(this.template(), this.shadowRoot);
  }

  _commentSaved(msg, data) {
    var commenttextArea = this.shadowRoot.querySelector("#commenttext");
    commenttextArea.value = "";
  }

  template() {
    return html`
      <style>
        div {
          display: flex;
          align-items: center;
          flex-direction: column;
          padding: 0;
          --_ui5_panel_content_padding: 0;
        }
        /* ui5-textarea {
                    width: 80%;
                } */
        ui5-button {
          height: 100%;
          padding: 0.5rem;
          margin-top: 0;
          align-self: flex-end;
          margin-bottom: 1rem;
        }
      </style>
      <div>
        <!--<ui5-label id="myLabel" for="commenttext">${this.string[
          "_leaveyourcomment"
        ]}</ui5-label>-->
        <ui5-textarea
          id="commenttext"
          placeholder="${this.string["_commentformplaceholder"]}"
          maxlength="4500"
          growing
          growing-max-lines="15"
          value="${this.comment}"
        ></ui5-textarea>
        <ui5-button @click="${this._saveComment.bind(this)}" design="Emphasized"
          >${this.string["_submitcomment"]}</ui5-button
        >
      </div>
    `;
  }

  _saveComment() {
    var commenttextArea = this.shadowRoot.querySelector("#commenttext");
    if (commenttextArea.value.length > 0) {
      if (this.commentid) {
        this.text = commenttextArea.value;
        var params = {};
        params.commentid = this.commentid;
        params.text = this.text;
        params.kbrid = this.kbrid;
        storeInstance.dispatch("updateComment", params);
      } else {
        var params = {};
        params.kbrid = this.kbrid; //+ "_1"
        params.weburi = window.location.href;
        params.text = commenttextArea.value;
        storeInstance.dispatch("addComment", params);
      }
    }
  }
}

customElements.define("kb-comment-form", KbCommentForm);
